// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"2be906db","388":"46618742","415":"fbe239c5","453":"793684db","574":"c822f66c","581":"8ca41391","667":"53335569","668":"aa37cfc5"}[chunkId] + ".chunk.js";
};